
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

export const CalendarLegend: React.FC = () => {
  return (
    <Card className="glass-card border-border/50 shadow-lg">
      <CardHeader>
        <CardTitle className="text-foreground font-light text-xl">Legend</CardTitle>
      </CardHeader>
      <CardContent className="space-y-3 text-sm text-muted-foreground leading-relaxed">
        <div>• <strong className="text-foreground">Astronomical Twilight:</strong> When the sun is 18° below horizon - true dark sky begins</div>
        <div>• <strong className="text-foreground">Galactic Core (GC):</strong> When the Milky Way's galactic center (Sagittarius A*) is visible above the horizon during astronomical darkness</div>
        <div>• <strong className="text-foreground">Moon Phase:</strong> Percentage of lunar illumination (0% = New Moon, 100% = Full Moon)</div>
        <div>• <strong className="text-foreground">Visibility Rating:</strong> 10 bars = Perfect conditions (new moon + core visible), 0 bars = Not viable for photography</div>
      </CardContent>
    </Card>
  );
};
